import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faBoxOpen } from '@fortawesome/free-solid-svg-icons';
import { UI_COLORS } from '../../utils/colors.jsx';
import { useTranslation } from 'react-i18next';

const fmt = (val) => {
    const n = parseFloat(val);
    if (!val || isNaN(n)) return '—';
    return n.toLocaleString('en-IN', { maximumFractionDigits: 2 });
};

const SupervisorWorkloadTable = ({ items = [], loading, onSelectSupervisor }) => {
    const { t } = useTranslation();
    if (loading) {
        return (
            <div className="flex items-center justify-center py-16 gap-2" style={{ color: UI_COLORS.TEXT.MUTED }}>
                <FontAwesomeIcon icon={faSpinner} className="animate-spin" />
                <span className="text-sm">Loading workload…</span>
            </div>
        );
    }

    if (!items.length) {
        return (
            <div className="flex flex-col items-center justify-center py-16 gap-2" style={{ color: UI_COLORS.TEXT.MUTED }}>
                <FontAwesomeIcon icon={faBoxOpen} className="text-3xl opacity-30" />
                <p className="text-sm">No active workload found</p>
            </div>
        );
    }

    return (
        <div className="rounded-xl border overflow-hidden" style={{ borderColor: UI_COLORS.BORDERS.LIGHT }}>
            <table className="w-full text-sm border-collapse">
                <thead>
                    <tr style={{ backgroundColor: '#f9fafb', borderBottom: `2px solid ${UI_COLORS.BORDERS.LIGHT}` }}>
                        <th className="px-4 py-3 text-left text-xs font-bold uppercase tracking-wider text-gray-500">{t('common.analyticsColumns.supervisor')}</th>
                        <th className="px-4 py-3 text-center text-xs font-bold uppercase tracking-wider text-gray-500">{t('common.analyticsColumns.assigned')}</th>
                        <th className="px-4 py-3 text-center text-xs font-bold uppercase tracking-wider text-gray-500">{t('common.analyticsColumns.loading')}</th>
                        <th className="px-4 py-3 text-center text-xs font-bold uppercase tracking-wider text-gray-500">{t('common.analyticsColumns.loaded')}</th>
                        <th className="px-4 py-3 text-center text-xs font-bold uppercase tracking-wider text-gray-500">{t('common.analyticsColumns.total')}</th>
                        <th className="px-4 py-3 text-right text-xs font-bold uppercase tracking-wider text-gray-500">{t('common.analyticsColumns.pendingWt')}</th>
                        <th className="px-4 py-3 text-right text-xs font-bold uppercase tracking-wider text-gray-500">{t('common.analyticsColumns.loadedWt')}</th>
                    </tr>
                </thead>
                <tbody>
                    {items.map((row, idx) => {
                        const isUnassigned = row.delivery_supervisor_id === null;
                        return (
                            <tr
                                key={row.delivery_supervisor_id ?? 'unassigned'}
                                onClick={() => !isUnassigned && onSelectSupervisor?.(row)}
                                className="transition-colors"
                                style={{
                                    borderTop: `1px solid ${UI_COLORS.BORDERS.LIGHT}`,
                                    backgroundColor: '#fff',
                                    cursor: isUnassigned ? 'default' : 'pointer',
                                }}
                                onMouseEnter={e => { if (!isUnassigned) e.currentTarget.style.backgroundColor = '#f9fafb'; }}
                                onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#fff'; }}
                            >
                                <td className="px-4 py-3">
                                    <p className="font-semibold text-base text-gray-900">
                                        {row.supervisor_name ?? 'Unassigned'}
                                    </p>
                                    {row.supervisor_mobile && (
                                        <p className="text-sm text-gray-500 mt-0.5">{row.supervisor_mobile}</p>
                                    )}
                                </td>

                                <td className="px-4 py-3 text-center text-xl font-black text-gray-900">{row.assigned_count ?? 0}</td>
                                <td className="px-4 py-3 text-center text-xl font-black text-gray-900">{row.loading_count  ?? 0}</td>
                                <td className="px-4 py-3 text-center text-xl font-black text-gray-900">{row.loaded_count   ?? 0}</td>
                                <td className="px-4 py-3 text-center text-xl font-black text-gray-900">{row.pending_sub_orders ?? 0}</td>

                                <td className="px-4 py-3 text-right text-base font-bold text-gray-900">
                                    {fmt(row.pending_loading_weight)} <span className="text-sm font-normal text-gray-400">kg</span>
                                </td>
                                <td className="px-4 py-3 text-right text-base font-bold text-gray-900">
                                    {fmt(row.loaded_weight)} <span className="text-sm font-normal text-gray-400">kg</span>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default SupervisorWorkloadTable;
